import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';

// ---------------------------------------------------------

import Icon from '@components/icon';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const {
  dropdown_menu_inner,
  dropdown_menu,
  open_house,
  open_house_date,
  open_house_date_secondary,
  open_houses_wrapper
} = styles;

// ---------------------------------------------------------

const OpenHousesDropdown = (props) => {
  let { openHouses, label } = props;

  // ---------------------------------------------------------

  const [dropdownHeight, setDropdownHeight] = useState(0);

  const handleDropdownState = () => {
    if (dropdownHeight === 'auto') {
      setDropdownHeight(0);
    } else {
      setDropdownHeight('auto');
    }
  };

  // ---------------------------------------------------------

  const classes = classNames(dropdown_menu);

  // ---------------------------------------------------------

  return (
    <OutsideClickHandler onOutsideClick={() => setDropdownHeight(0)}>
      <ul className={open_houses_wrapper}>
        <li className={open_house_date}>
          {openHouses.length == 1 && (
            <div className={classNames(open_house)}>
              Open:&nbsp;<span>{label}</span>
            </div>
          )}
          {openHouses.length > 1 && (
            <button
              aria-expanded={dropdownHeight !== 0}
              aria-controls={label}
              className={classNames(open_house)}
              onClick={handleDropdownState}
            >
              Open:&nbsp;<span>{label}</span>
              <Icon name="small-down" type="arrow" />
            </button>
          )}
        </li>
        <AnimateHeight
          animateOpacity={true}
          className={classes}
          contentClassName={dropdown_menu_inner}
          duration={300}
          height={dropdownHeight}
          id={label}
        >
          <>
            {openHouses.slice(1).map((item, index) => {
              return (
                <li key={index} className={classNames(open_house_date, open_house_date_secondary)}>
                  Open:&nbsp;<span>{item.formattedDateTimeDisplay}</span>
                </li>
              );
            })}
          </>
        </AnimateHeight>
      </ul>
    </OutsideClickHandler>
  );
};

OpenHousesDropdown.propTypes = {
  /**
   * Specifies the dropdown label
   */
  label: PropTypes.string.isRequired,

  /**
   * Specifies the dropdown elements
   */
  openHouses: PropTypes.array.isRequired
};

export default OpenHousesDropdown;
